"use client";

import { useState, useEffect } from "react";
import { motion, AnimatePresence } from "framer-motion";
import Cookies from "js-cookie";

export default function CookieBanner() {
    const [showBanner, setShowBanner] = useState(false);

    useEffect(() => {
        // Vérifie si un choix a déjà été fait
        const consent = Cookies.get("wearebiam-cookie-consent");
        if (!consent) {
            setShowBanner(true);
        }
    }, []);

    const acceptCookies = () => {
        Cookies.set("wearebiam-cookie-consent", "accepted", { expires: 180 });
        setShowBanner(false);
        // 👉 Ici tu peux lancer Google Analytics ou autres scripts
    };

    const declineCookies = () => {
        Cookies.set("wearebiam-cookie-consent", "declined", { expires: 180 });
        setShowBanner(false);
    };

    return (
        <AnimatePresence>
            {showBanner && (
                <motion.div
                    initial={{ y: 100, opacity: 0 }}
                    animate={{ y: 0, opacity: 1 }}
                    exit={{ y: 100, opacity: 0 }}
                    transition={{ duration: 0.4 }}
                    className="fixed lg:bottom-[100px] bottom-[50px] lg:right-0 lg:transform lg:-translate-x-1/2 lg:w-[350px] w-[95%] max-w-2xl bg-black text-white p-4  shadow-lg z-50 flex flex-col items-center justify-between gap-4"
                >
                    <p className="text-sm text-center md:text-left">
                        Nous utilisons des cookies tiers afin d'améliorer votre expérience sur le site.
                    </p>
                    <div className="grid grid-cols-2 w-full gap-3">
                        <button
                            onClick={declineCookies}
                            className="px-4 py-2 bg-gray-700 hover:bg-gray-600 text-sm"
                        >
                            Je refuse
                        </button>
                        <button
                            onClick={acceptCookies}
                            className="px-4 py-2 bg-white active:bg-black text-black active:text-white text-sm"
                        >
                            J’accepte
                        </button>
                    </div>
                </motion.div>
            )}
        </AnimatePresence>
    );
}
